import request from './request';
import deserialize from './deserialize';

export type Restriction = {
  id: string;
  createdAt: number;
  type: string;
  restriction: string[];
  updateAt: number;
  employment: { id: string };
};

export function listEmployeeRestriction(companyId: string, employeeId: string) {
  return request<Restriction[]>({
    url: `/v1/companies/${companyId}/employment/${employeeId}/restrictions`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
